import styled from 'styled-components'
const WrapFilterUsers = styled.div`
    position: relative;

`
export { WrapFilterUsers }